// @ts-nocheck
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CreateOrderDialog from './CreateOrderDialog';

const CreateOrderButton = ({ disabled, isLaw, customer }) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleAccept = async () => setOpen(false);

    return (
        <>
            <Button
                style={{ marginRight: 10 }}
                disabled={ disabled }
                endIcon={ <AddIcon /> }
                variant="contained"
                onClick={ handleClickOpen }
            >
                Opret ny ordre
            </Button>
            <CreateOrderDialog
                isLaw={ isLaw }
                customerInput={ customer }
                open={ open }
                onClose={ handleClose }
                onAccept={ handleAccept }
            />
        </>
    );
};

export default CreateOrderButton;
